/* global G */

import { curry } from 'lib/util'

/**
 * Notification Event Dispatcher
 *
 * Calls the `type` method on the notification adapter and either waits for `G.NOTIFICATION, G.DONE`
 * event, if `immediate` is falsy. Returns the value of the method immediately otherwise.
 *
 * @param {'alert'|'message'|'cart'} group  the group name / type of the notification
 * @param {Gaia.AppModule.Spec} module      module composition
 * @param {EventBus.type} type              type of the event
 * @param {boolean} [immediate=false]       whether the method returns an immediate result
 *                                          and should therefore be returned withouth waiting
 *                                          for the `G.DONE` event
 * @param {Object} detail                   data for the cart adapter
 * @param {Function} [callback=null]        optional callback to execute
 * @returns {(function(): Promise<void>)|*}
 */
const seqModuleAdapterEventsDispatchFn = (group, module, type, detail, callback = null, immediate = false) => async () => {
  const eventBus = module[G.ADAPTER][G.EVENTS]
  const notificationGroupApi = module[G.ADAPTER][G.NOTIFICATION][G.GROUP][group][G.API]

  const notificationData = immediate
    ? null
    : await new Promise((resolve) => {
      eventBus.add(eventBus.type(G.NOTIFICATION, G.DONE, group), ({ detail: cart }) => {
        const { [G.DATA]: currentNotification } = cart
        resolve(currentNotification)
      }, { once: true })

      !immediate && notificationGroupApi[type]({ detail })
    })

  const result = !immediate
    ? null
    : await notificationGroupApi[type]({ detail });

  (result || notificationData) && await callback?.(result || notificationData)

  return immediate
    ? result || notificationData
    : undefined
}

export const seqModuleAdapterAlertEventsDispatch = curry(seqModuleAdapterEventsDispatchFn)('alert')
export const seqModuleAdapterMessageEventsDispatch = curry(seqModuleAdapterEventsDispatchFn)('message')
